export * from './multiselect-wrapper'



// WEBPACK FOOTER //
// ./src/app/shared/components/multiselect-wrapper/index.ts